import React, { ReactNode } from 'react';
import { useHeaderHeight } from '@react-navigation/elements';
import { isWeb } from 'utils/deviceUtils';
import { ColumnWithMargins, ScreenWrapper } from 'styles/ContainerStyles';

const ModalContentWrapper = ({ children }: { children: ReactNode }) => {
  const headerHeight = useHeaderHeight();

  return isWeb ? (
    <ScreenWrapper tabBarHeight={headerHeight}>{children}</ScreenWrapper>
  ) : (
    <ColumnWithMargins ml={20} mr={20}>
      {children}
    </ColumnWithMargins>
  );
};

export default ModalContentWrapper;
